import { useEffect, useState } from 'react'
import * as apiIndex from '@/apis/index'

const usePrivateOssUrl = (src?: string) => {
  const [privateOSSUrl, setPrivateOSSUrl] = useState<string>('')
  const getPrivateOSSUrl = async (key: string) => {
    const url = await apiIndex.aliyun_oss_temp_link({ key })
    setPrivateOSSUrl(url)
  }

  useEffect(() => {
    // 无协议头，并且不是 / 开头，则认为是私有OSS图片
    if (
      src &&
      !src.includes('://') && // 有协议头
      !src.startsWith('/') && // 不是 / 开头
      !src.startsWith('data:') // 不是 data: 开头
    ) {
      getPrivateOSSUrl(src)
    } else {
      setPrivateOSSUrl(src || '')
    }
  }, [src])
  return privateOSSUrl
}

export default usePrivateOssUrl
